import React from 'react';
import { noop } from 'lodash';
import PropTypes from 'prop-types';

import Modal from '../../common/Modal';
import Spinner from '../../common/Spinner';
import OverlaySpinner from '../../common/OverlaySpinner';

const ConnectionSpinner = ({ stage, selectedReader, isProcessor }) => {
  const label = stage === 'connect' ? `Connecting to ${selectedReader.label}...` : '';

  if (!isProcessor) {
    return (
      <OverlaySpinner showForContainerApp>
        {label}
      </OverlaySpinner>
    );
  }

  return (
    <Modal
      title={label}
      close={noop}
      className="c-modal__shadowed"
      overlayClassName="u-bg-transparent"
    >
      <div className="u-ph++ u-pv u-text-center">
        <Spinner showForContainerApp />
        <button
          type="button"
          className="c-btn c-btn--primary u-mt+"
          onClick={noop}
          disabled
        >
          Cancel
        </button>
      </div>
    </Modal>
  );
};

ConnectionSpinner.propTypes = {
  isProcessor: PropTypes.bool,
  stage: PropTypes.string.isRequired,
  selectedReader: PropTypes.object,
};

ConnectionSpinner.defaultProps = {
  isProcessor: false,
  selectedReader: null,
};

export default ConnectionSpinner;
